import Router from "./route";
import React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faTwitter, faFontAwesome } from "@fortawesome/free-brands-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faCheckSquare, faCoffee } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from "react-toastify";
import { CommonContextProvider } from "./Utils/commonContext";
library.add(fas, faTwitter, faFontAwesome, faCheckSquare, faCoffee, fab);

const ErrorBoundary = React.lazy(() => import("./error-boundry"));
function App() {
  return (
    <>
      <ErrorBoundary>
        <CommonContextProvider>
          <Router></Router>
          <ToastContainer />
        </CommonContextProvider>
      </ErrorBoundary>
    </>
  );
}

export default App;
